import { Route, Routes } from "react-router-dom";
import { Routes as RouterRoutes } from "../../helpers/router";
import { Dashboard } from "../../views/dashboard/dashboard";
import { Login } from "../../views/login/login";
import { NotFound } from "../../views/not-found/not-found";
import { Profiles } from "../../views/profiles/profiles";
import { ResetPassword } from "../../views/reset-password/reset-password";
import { TaxProfile } from "../../views/tax-profile/tax-profile";
import { UserManagement } from "../../views/usermgmt/usermgmt";
import { PrivateRoutes } from "./private-routes";
import { ProfileRoutes } from "./profile-routes";
import { ProtectedRoutes } from "./protected-routes";
import { UnauthRoutes } from "./unauth-routes";

export const WebRoutes = () => (
  <Routes>
    <Route element={<ProfileRoutes maxWidth="container.sm" bg="slate.50" />}>
      <Route index element={<Dashboard />} />
    </Route>
    <Route element={<ProfileRoutes />}>
      <Route path={RouterRoutes.TaxProfile()} element={<TaxProfile />} />
    </Route>
    <Route element={<PrivateRoutes />}>
      <Route path={RouterRoutes.Profiles()} element={<Profiles />} />
    </Route>
    <Route element={<ProtectedRoutes />}>
      <Route path={RouterRoutes.Login()} element={<Login />} />
    </Route>
    <Route element={<UnauthRoutes />}>
      <Route
        path={RouterRoutes.UserManagement()}
        element={<UserManagement />}
      />
      <Route
        path={RouterRoutes.ResetPassword()}
        element={<ResetPassword />}
      />
    </Route>
    <Route path="*" element={<NotFound />} />
  </Routes>
);
